import reportsChartsComponentUrl from './reportsChartsComponent.html';

export default {
  bindings: {
    mode: '<',
    data: '<',
    range: '<',
    userIds: '<?',
    locationIds: '<?',
    showDurationsAsDecimals: '<?',
  },
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './reportsChartsComponentCtrl')).default,
  templateUrl: reportsChartsComponentUrl,
};
